<template>


    <div>

        <!--初创企业补贴-->

        <!--中间的标题-->
        <div class="title">
            <div class="leftTitle" @click="clickLeft">
                <div class="leftTitle" v-if="leftAtive">
                    <div class="letf" style="color: #1592E6">服务介绍</div>
                    <div class="letfLine" style="background-color: #1592E6"/>
                </div>

                <div class="leftTitle" v-else>
                    <div class="letf" style="color: black">服务介绍</div>
                    <div class="letfLine" style="background-color: white"/>
                </div>
            </div>

            <div class="rightTitle" @click="clickFile">
                <div class="rightTitle" v-if="rightAtive">
                    <div class="right" style="color: #1592E6">相关附件</div>
                    <div class="rightLine" style="background-color: #1592E6"/>
                </div>

                <div class="rightTitle" v-else>
                    <div class="right" style="color: black">相关附件</div>
                    <div class="rightLine" style="background-color: white"/>
                </div>
            </div>
        </div>


        <div class="floatLoad" v-if="!isHide">
            <!--<van-loading type="spinner" />-->
            <van-loading size="24px">加载中...</van-loading>
        </div>

        <!--标题相应的内容 -->
        <div v-if="leftAtive" class="image">
            <!--财税-->
            <!--<img src="../assets/logo.png"/>-->
            <!--<img v-if="introduceImage !== '' " class="image" :src="introduceImage"/>-->

            <div v-if="content !== '' " class="image" v-html="content"></div>
            <div v-else class="withoutContent">暂无服务介绍</div>
        </div>

        <div v-else class="file">
            <!--政策文件 -->
            <div v-if="contents.length > 0">
                <div class="cell" v-for="item in contents" :key="item.id">
                    <div class="content">
                        <!-- <div class="fileName"  @click="openPDF(item)">{{item.name}}</div> -->
						<div class="fileName" @click="doCopy(item.url)">{{item.name}}</div>
                        <!--<img :hidden="!isAndroid" class="downLoad" src="../assets/downLoad.png"/>-->
<!--                        <a :href="item.url">-->
<!--                            <img class="downLoad" src="../../assets/downLoad.png"/>-->
<!--                        </a>-->
                        <img class="downLoad" @click="downLoad(item)" src="../../assets/downLoad.png"/>
<!--                        <div v-if="isOpen" class="pdfClass">
                            <pdf :url="scrUrl" @click.native.stop="clickHide"/>
                           <iframe width="100%" height="100%" :src="scrUrl"></iframe>
                        </div> -->
                    </div>

                </div>
            </div>


            <div v-if="contents.length === 0" class="withoutContent">暂无相关附件</div>

        </div>
    </div>


</template>

<script>

    import {mapGetters} from 'vuex'
    import {Toast} from "vant";
    // import pdf from '../../components/Pdf'

    export default {
        name: 'StartupCompany',

        data() {
            return {
                leftAtive: true,
                rightAtive: false,
                contents: [],
                introduceImage: '',
                isHide: false,
                isOpen: false,
                scrUrl: '',
                content:''
            }
        },
        // components: {
        //     pdf
        // },

        watch: {
            communityId() {
                this.getData()
            }
        },

        //网络请求
        created() {
            if (this.communityId.length > 0) {
                this.getData()
            }
        },

        computed: {

            ...mapGetters(['token', 'userId', 'communityId']),
            // 判断是什么手机
            isAndroid() {
                var u = navigator.userAgent;
                var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                return isiOS ? false : true
            }
        },
        methods: {
            clickHide(){
                this.isOpen = false
            },
            openPDF(item) {
                console.log('打开pdf', this.isOpen, item)

                if (item.url.substring(item.url.length - 3) === 'pdf') {
                    this.isOpen = !this.isOpen
                    this.scrUrl = item.url
                    // window.location.href = item.url
                } else {
                    Toast('只能打开pdf格式文件');
                }


            },
            downLoad(item) {
                console.log('下载', item)
                // item.isLoad = !item.isLoad

                window.location.href = item.url
            },
			doCopy(res) {
				this.$copyText(res).then(()=> {
					Toast.success('下载地址已复制到剪贴板');
				}, ()=> {
					Toast.fail('下载地址复制失败');
				});
			},
            onClickLeft() {
                // Toast('返回');
                console.log('返回')
            },
            clickLeft() {
                console.log('左边', this.isAndroid)
                this.leftAtive = true
                this.rightAtive = false
            },
            clickFile() {
                console.log('右边')
                this.leftAtive = false
                this.rightAtive = true
            },
            getData() {

                let url = `${this.vaxios.host}` + '/open/api/v1/subsidy-policies/status/published'
                //注意:园区id从app里取
                let param = {communityId: this.communityId, abilityItemId: this.$route.query.abilityItemId}

                this.vaxios.get(url, param, res => {
                    this.contents = []
                    console.log('成功', res)
                    this.isHide = true
                    if (res.code === 1) {
                        if (res.data !== undefined && res.data.attachs.length > 0) {
                          this.content = res.data.content
                            res.data.attachs.forEach(p => {
                              //初创企业文件

                              let item = {}
                              item.name = p.attach_name
                              item.url = p.attach_url
                              item.isLoad = false
                              this.contents.push(item)

                            })
                        }
                    }


                }, error => {
                    this.isHide = true
                    console.log('失败', error)
                })
            }
        }
    }
</script>

<style>
    @import "../../assets/common.css";


</style>
